import HtmlElement from './HtmlElement';

const TextAnimation = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		TEXT_ANIMATION: '.text-animation',
		TEXT_ANIMATION_TEXTS: '.text-animation-texts'
	};

	/**
	 * TextAnimation
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class TextAnimation extends HtmlElement {
		onReady() {
			this.$element.find(Selector.TEXT_ANIMATION_TEXTS).each((i, el) => {
				$(el).teletype( {
					text: $(el).data('texts') || [],
					typeDelay: 0,
					backDelay: 20
				});
			});
		}
	}
	return TextAnimation._getElements(Selector.TEXT_ANIMATION, TextAnimation);
})();

export default TextAnimation;
